import ReactEDSWrapper from '../../../utils/react-eds-wrapper';
import { Button, Input, Table, Row, Cell, Pagination } from '@dsi/react-eds';
import styles from './UsersTable.module.css';

interface UsersTableProps {
  users: { email: string; roles: string[]; role: string, id: string }[];
  page: number;
  pageSize: string;
  numPages: number;
  filterEmail: string;
  filterRole: string;
  sortAttr: 'email' | 'role' | undefined;
  sortOrder: 'asc' | 'desc' | undefined;
  onEdit: (idx: number) => void;
  onDelete: (idx: number) => void;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: string) => void;
  onSort: (order: 'asc' | 'desc', attr: 'email' | 'role') => void;
  onFilterEmail: (val: string) => void;
  onFilterRole: (val: string) => void;
}

const UsersTable: React.FC<UsersTableProps> = ({
  users,
  page,
  pageSize,
  numPages,
  filterEmail,
  filterRole,
  sortAttr,
  sortOrder,
  onEdit,
  onDelete,
  onPageChange,
  onPageSizeChange,
  onSort,
  onFilterEmail,
  onFilterRole,
}) => {
  const columns = [
    {
      title: 'Email',
      attribute: 'email',
      sortable: true,
      width: '50%',
      sortOrder: sortAttr === 'email' ? sortOrder : undefined,
    },
    {
      title: 'Role',
      attribute: 'role',
      sortable: true,
      sortOrder: sortAttr === 'role' ? sortOrder : undefined,
    },
    { title: '', attribute: 'actions', },
  ];

  return (
    <div className={styles.userListContainer}>
      <div className={styles.userListInfo}>
        {users.length > 0 ? `${(page - 1) * parseInt(pageSize, 10) + 1} - ${Math.min(page * parseInt(pageSize, 10), users.length)} of ${users.length} items` : null}
      </div>
      <ReactEDSWrapper
        component={Table}
        columns={columns}
        filters={
          <ReactEDSWrapper component={Row}>
            <ReactEDSWrapper component={Cell}>
              <ReactEDSWrapper
                component={Input}
                className={styles.searchField}
                placeholder="Filter"
                type="search"
                value={filterEmail}
                onChange={e => {
                  const value = (e.target as HTMLInputElement).value;
                  onFilterEmail(value);
                }}
              />
            </ReactEDSWrapper>
            <ReactEDSWrapper component={Cell}>
              <ReactEDSWrapper
                component={Input}
                className={styles.searchField}
                placeholder="Filter"
                type="search"
                value={filterRole}
                onChange={e => {
                  const value = (e.target as HTMLInputElement).value;
                  onFilterRole(value);
                }}
              />
            </ReactEDSWrapper>
            <ReactEDSWrapper component={Cell} />
          </ReactEDSWrapper>
        }
        showFilters
        sortable
        onSort={(order: 'asc' | 'desc', attr: 'email' | 'role') => {
          onSort(order, attr);
        }}
      >
        {users.map((user, idx) => (
          <ReactEDSWrapper component={Row} key={idx}>
            <ReactEDSWrapper component={Cell} className={styles.emailCell}>{user.email}</ReactEDSWrapper>
            <ReactEDSWrapper component={Cell}>{user.role}</ReactEDSWrapper>
            <ReactEDSWrapper component={Cell} className={styles.actionCell}>
              <ReactEDSWrapper
                component={Button}
                className={`btn icon-btn ${styles.iconBtn}`}
                aria-label="Edit"
                onClick={() => onEdit(idx)}
              >
                <i className="icon icon-edit"></i>
              </ReactEDSWrapper>
              <ReactEDSWrapper
                component={Button}
                className={`btn icon-btn ${styles.iconBtn}`}
                aria-label="Delete"
                onClick={() => onDelete(idx)}
              >
                <i className="icon icon-trashcan"></i>
              </ReactEDSWrapper>
            </ReactEDSWrapper>
          </ReactEDSWrapper>
        ))}
      </ReactEDSWrapper>
      <ReactEDSWrapper
        component={Pagination}
        numPages={numPages}
        selectedPage={page}
        onPaginationChangePage={onPageChange}
        optionsList={[
          { value: '10', label: '10', active: pageSize === '10' },
          { value: '20', label: '20', active: pageSize === '20' },
          { value: '30', label: '30', active: pageSize === '30' },
        ]}
        onPaginationChangeSelect={onPageSizeChange}
        withActions
      />
    </div>
  );
};

export default UsersTable;